import dayjs from "dayjs";
import type { SupportedLocale } from "./detectLanguage";

export const loadDayjsLocale = async (
  locale: SupportedLocale
): Promise<void> => {
  switch (locale) {
    case "en":
      await import("dayjs/locale/en");
      dayjs.locale("en");
      return;
    case "es":
      await import("dayjs/locale/es");
      dayjs.locale("es");
      return;
    case "pt-BR":
      await import("dayjs/locale/pt-br");
      dayjs.locale("pt-br");
      return;
    case "fr":
      await import("dayjs/locale/fr");
      dayjs.locale("fr");
      return;
    case "de":
      await import("dayjs/locale/de");
      dayjs.locale("de");
      return;
    case "th":
      await import("dayjs/locale/th");
      dayjs.locale("th");
      return;
  }
};
